export enum MonthOption {
	NONE = '',
	JAN = 'Jan',
	FEB = 'Feb',
	MAR = 'Mar',
	APR = 'Apr',
	MAY = 'May',
	JUN = 'Jun',
	JUL = 'Jul',
	AUG = 'Aug',
	SEP = 'Sep',
	OCT = 'Oct',
	NOV = 'Nov',
	DEC = 'Dec',
}

export enum ApiMonthOption {
	NONE = -1,
	JAN = 1,
	FEB = 2,
	MAR = 3,
	APR = 4,
	MAY = 5,
	JUN = 6,
	JUL = 7,
	AUG = 8,
	SEP = 9,
	OCT = 10,
	NOV = 11,
	DEC = 12,
}

export function isApiMonthOption(_: ApiMonthOption | MonthOption): _ is ApiMonthOption {
	return typeof _ === 'number' && Object.values(ApiMonthOption).includes(_);
}

/**
 * Used as input to some APIs
 */
export const MONTH_OPTIONS_AS_NUMBERS = {
	[MonthOption.NONE]: ApiMonthOption.NONE,
	[MonthOption.JAN]: ApiMonthOption.JAN,
	[MonthOption.FEB]: ApiMonthOption.FEB,
	[MonthOption.MAR]: ApiMonthOption.MAR,
	[MonthOption.APR]: ApiMonthOption.APR,
	[MonthOption.MAY]: ApiMonthOption.MAY,
	[MonthOption.JUN]: ApiMonthOption.JUN,
	[MonthOption.JUL]: ApiMonthOption.JUL,
	[MonthOption.AUG]: ApiMonthOption.AUG,
	[MonthOption.SEP]: ApiMonthOption.SEP,
	[MonthOption.OCT]: ApiMonthOption.OCT,
	[MonthOption.NOV]: ApiMonthOption.NOV,
	[MonthOption.DEC]: ApiMonthOption.DEC,
};

export const API_NUMBERS_TO_MONTH_OPTION = {
	'-1': MonthOption.NONE,
	1: MonthOption.JAN,
	2: MonthOption.FEB,
	3: MonthOption.MAR,
	4: MonthOption.APR,
	5: MonthOption.MAY,
	6: MonthOption.JUN,
	7: MonthOption.JUL,
	8: MonthOption.AUG,
	9: MonthOption.SEP,
	10: MonthOption.OCT,
	11: MonthOption.NOV,
	12: MonthOption.DEC,
};

export const MONTH_NUMBER_FOR_KEY = {
	[MonthOption.NONE]: 0,
	[MonthOption.JAN]: 0,
	[MonthOption.FEB]: 1,
	[MonthOption.MAR]: 2,
	[MonthOption.APR]: 3,
	[MonthOption.MAY]: 4,
	[MonthOption.JUN]: 5,
	[MonthOption.JUL]: 6,
	[MonthOption.AUG]: 7,
	[MonthOption.SEP]: 8,
	[MonthOption.OCT]: 9,
	[MonthOption.NOV]: 10,
	[MonthOption.DEC]: 11,
};

export const DEFAULT_VALUE = MonthOption.NONE;
